import React from "react"

class EmailTimePeriodDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.row.time_period && this.props.row.time_value == null) {
      return (
        <div>
          {I18n.t(this.props.row.time_period)}
        </div>
      );
    }
    else if(this.props.row.time_period && this.props.row.time_value) {
      return (
        <div>
          {`${I18n.t(this.props.row.time_period)} (${this.props.row.time_value} ${I18n.t('days')})`}
        </div>
      )
    } else {
      return (
        <div>
          <em>
            {I18n.t('none')}
          </em>
        </div>
      )
    } 
  }

};

export default EmailTimePeriodDataType